export const data = {
    labels: [''],
    datasets: [
        {
            label: '',
            lineTension: 0,
            data: [0],
            // Linie und Legende in Gruen
            borderColor: "rgba(34, 197, 94, 1)",
            backgroundColor: "rgba(34, 197, 94, 0.85)",
            borderWidth: 2,
            pointBackgroundColor: "rgba(34, 197, 94, 1)",
            pointBorderColor: "#fff",
            pointRadius: 4,
            pointHoverRadius: 6
        }
    ]
};

export const data2 = {
    labels: [''],
    datasets: [
        {
            label: '',
            lineTension: 0,
            data: [0],
            // Linie und Legende in Amber/Gelb
            borderColor: "rgba(251, 191, 36, 1)",
            backgroundColor: "rgba(251, 191, 36, 0.7)",
            borderWidth: 2,
            pointBackgroundColor: "rgba(251, 191, 36, 1)",
            pointBorderColor: "#fff",
            pointRadius: 4,
            pointHoverRadius: 6
        }
    ]
};
